const initialState = {
  obj: {}
}

const agencyDataRed = (state = initialState, action) => {
  switch (action.type) {
    case 'AGENCY_DATA': {
      return {
        ...state,
        obj: action.obj
      }
    }
    default: {
      return state
    }
  }
}

export default agencyDataRed
